import { render, staticRenderFns } from "./StaticField.vue?vue&type=template&id=3cc3dfb9&"
import script from "./StaticField.vue?vue&type=script&lang=js&"
export * from "./StaticField.vue?vue&type=script&lang=js&"
import style0 from "./StaticField.vue?vue&type=style&index=0&id=3cc3dfb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports